import { ATTENDANCE_LOG_TYPES } from "./constants";

/**
 * @param {AttendanceLog} form
 * @returns {AttendanceLog}
 */
export function initAttendanceLog(form = {}) {
    return {
        ...(form || {}),

        _code: form?._code || null,
        _person: form?._person || null,
        _company: form?._company || null,
        _contract: form?._contract || null,
        _application: form?._application || null,

        type: form?.type ?? ATTENDANCE_LOG_TYPES.INIT.value,
        date: form?.date,
        subject: form?.subject,
        isManual: form?.isManual ?? false,
    };
}

/**
 * @typedef {object} AttendanceLog
 *
 * @property {string} _code
 * @property {string} _person
 * @property {string} _company
 * @property {string} _contract
 * @property {string} _application
 *
 * @property {string} type
 * @property {string} date
 * @property {string} subject
 * @property {boolean} isManual
 *
 */
